/**
 * Created by chenqifeng on 2016/9/1.
 */
let startTime = Date.now();
export let loadAppInterface = function(deferred){
    if(/hybrid=true/.test(document.cookie) && !/global=airmall/.test(document.cookie)){
        var key = setInterval(function(){
            let currentTime = Date.now();

	        var target
	            ;

	        try{    // 新版 APP WebView 的交互方式
		        target =  window.webkit.messageHandlers.app;
	        }
	        catch(e){   // 旧版
		        target = window.app;
	        }

            if(typeof target === 'function' || typeof target === 'object' || (currentTime - startTime > 2000)){
                clearInterval(key);
                deferred.resolve();
            }
        },50)
    }else{
        deferred.resolve();
    }
};